export const CONSTANTS = {
    HTTP: {
        'SUCCESS': 200,
		'NO_CONTENT': 204,
		'NOT_FOUND': 404
    },
    STORE: {
				'ANSWER_MUTATION_NAME': 'save'
				// This store method may be deprecated. It has been commented out.
        // 'METADATA_MUTATION_NAME': 'saveMetadata'
    },
		/* Defines where a validation message is displayed. */
		VALIDATION_DISPLAY_TYPE: {
			'BANNER': 'Banner',
			'FIELD': 'Field'
		},
		/* Defines the severity of a validation message. */
		VALIDATION_SEVERITY_TYPE: {
			'INFO': 'Info',
			'WARNING': 'Warning',
			'ERROR': 'Error'
		},
    /* Defines the type of the WesQuestionNumber. */
    QUESTION_NUMBER_TYPE: {
        'DEFAULT': 'default',
        'ERROR': 'error',
        'TREND': 'trend'
    },
    /* Defines the type of Office Entity available in the system */
    OFFICE_ENTITY_TYPES: {
        'AGENCY': 'Agency',
        'PROGRAM': 'Program',
        'OFFICE': 'Office',
        'BRANCH': 'Branch',
        'ARRAY': ['Agency', 'Program', 'Office', 'Branch']
		},
		/* Defines the possible statuses of the survey itself. */
		SURVEY_STATUS: {
			'CREATED': 'Created',
			'NOT_STARTED': 'NotStarted',
			'IN_PROGRESS': 'InProgress',
			'ERRORS': 'Errors',
			'WARNINGS': 'Warnings',
			'COMPLETE': 'Complete',
			'SUBMITTED': 'Submitted'
		},
		QUESTION_STATUS: {
			'NOT_STARTED': 'NotStarted',
      'IN_PROGRESS': 'InProgress',
      'ERRORS': 'Errors',
      'WARNINGS': 'Warnings',
      'COMPLETE': 'Complete'
    },
    COUNTRY_STATIC_ROW_NAMES: {
			'A_ROW': 'International organizations',
			'C_ROW': 'Total'
    },
    LAYOUT_I_STATIC_ROW_NAMES: {
			'TOTAL': 'Total '
		},
		OFFICE_SUPPORT_ACTIONS: {
			'REQUEST_VIEW': 'View Support Requests',
			'REQUEST_ADD': 'Add New Support Request'
		}
};
